import Vue from 'vue';
import Popup from './main.vue';
const PopupBox = Vue.extend(Popup);
Popup.install = function (data) {
    const instance = new PopupBox({ data }).$mount();
    document.body.appendChild(instance.$el);
    Vue.nextTick(() => {
        instance.isShow = true;
    });
};
export default Popup;
